import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IconNames } from '@shared/enums/icon-names';
import { NotificationService } from '@core/services/notification.service';
import { FeedbackService } from '@core/services/feedback.service';
import { finalize, take } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { User } from '@core/models/user.model';
import { Dealer } from '@core/models/dealer.model';
import { FeedbackHelperService, FeedbackModel } from '@app/core/services/feedback-helper.service';
import { Store } from '@ngxs/store';
import { Theme } from '@app/support/models/theme.model';
import { Observable } from 'rxjs';
import { ThemeService } from '@app/core/services/theme.service';
import { OpenDialogService } from '@app/core/services/open-dialog.service';
import { FeedbackType } from '@app/core/models/feedback.model';
import { AsyncPipe } from '@angular/common';
import { IceTextareaComponent } from '@app/shared/components/molecules/ice-textarea/ice-textarea.component';
import { DiegoRatingComponent } from './diego-rating/diego-rating.component';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';

const diegoRatings = [
  {
    name: 'Dårlig',
    icon: IconNames.ice_worried,
  },
  {
    name: 'Greit',
    icon: IconNames.ice_unhappy,
  },
  {
    name: 'Bra',
    icon: IconNames.ice_satisfied,
  },
  {
    name: 'Perfekt',
    icon: IconNames.ice_laughing,
  },
];

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss'],
  imports: [IceButtonComponent, FormsModule, ReactiveFormsModule, DiegoRatingComponent, IceTextareaComponent, AsyncPipe],
})
export class FeedbackDialogComponent implements OnInit {
  data = inject<{
    user: User;
    activeDealer: Dealer;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<FeedbackDialogComponent>>(MatDialogRef);
  private deviceDetectorService = inject(DeviceDetectorService);
  private notificationService = inject(NotificationService);
  private feedbackService = inject(FeedbackService);
  private store = inject(Store);
  private cdr = inject(ChangeDetectorRef);
  private themeService = inject(ThemeService);
  private dialogService = inject(OpenDialogService);

  diegoRatings = diegoRatings;
  feedbackForm: FormGroup;

  isLoading: boolean;
  hasSubmittedSuccessfully: boolean = false;

  selectedTheme$: Observable<Theme>;

  ngOnInit() {
    this.feedbackForm = this.buildForm();
    this.selectedTheme$ = this.themeService.selectedTheme;
  }

  onClose() {
    this.dialogRef.close();
  }

  onSubmit() {
    const { feedback, rating } = this.feedbackForm.value;

    const options: FeedbackModel = {
      text: feedback,
      rating: rating + 1,
      deviceDetectorService: this.deviceDetectorService,
      store: this.store,
      feedbackType: FeedbackType.GeneralFeedback,
    };

    const newFeedback = FeedbackHelperService.getDefaultFeedback(options);
    this.isLoading = true;

    this.feedbackService
      .postFeedback(newFeedback)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        () => {
          this.hasSubmittedSuccessfully = true;
          this.cdr.detectChanges();
        },
        () => {
          this.notificationService.error('Noe gikk galt.');
        }
      );
  }

  openErrorDialog() {
    this.dialogRef.close();
    this.dialogService.openErrorDialog(this.data.user);
  }
  private buildForm(): FormGroup {
    return new FormGroup({
      rating: new FormControl(null, [Validators.required]),
      feedback: new FormControl(null, [Validators.required]),
    });
  }
}
